import { useQuery } from "@tanstack/react-query";
import { parsiMapReverseLocation } from "./mapApis";

export const useGetParsiMapLocation = (location: string, isEnabled = true) => {
  const { data, isLoading, refetch } = useQuery(["ParsiLocation", location], () => parsiMapReverseLocation({ location }), {
    cacheTime: 2000,
    enabled: isEnabled,
  });
  return { data, isLoading, refetch };
};
